import { IRootState } from '../../../store'
import { IPcrSummaries } from '../store/home.types'

export const getFilteredPCRDocsSelector = (state: IRootState): IPcrSummaries => state.home.filteredPCRDocs
